/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SupportUserRewardContextResponse
 */
export interface SupportUserRewardContextResponse {
    /**
     * 
     * @type {string}
     * @memberof SupportUserRewardContextResponse
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof SupportUserRewardContextResponse
     */
    referredByUserId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SupportUserRewardContextResponse
     */
    referredByUserEmail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SupportUserRewardContextResponse
     */
    promotionCode?: string | null;
}

/**
 * Check if a given object implements the SupportUserRewardContextResponse interface.
 */
export function instanceOfSupportUserRewardContextResponse(value: object): value is SupportUserRewardContextResponse {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    return true;
}

export function SupportUserRewardContextResponseFromJSON(json: any): SupportUserRewardContextResponse {
    return SupportUserRewardContextResponseFromJSONTyped(json, false);
}

export function SupportUserRewardContextResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupportUserRewardContextResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['user_id'],
        'referredByUserId': json['referred_by_user_id'] == null ? undefined : json['referred_by_user_id'],
        'referredByUserEmail': json['referred_by_user_email'] == null ? undefined : json['referred_by_user_email'],
        'promotionCode': json['promotion_code'] == null ? undefined : json['promotion_code'],
    };
}

export function SupportUserRewardContextResponseToJSON(json: any): SupportUserRewardContextResponse {
    return SupportUserRewardContextResponseToJSONTyped(json, false);
}

export function SupportUserRewardContextResponseToJSONTyped(value?: SupportUserRewardContextResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_id': value['userId'],
        'referred_by_user_id': value['referredByUserId'],
        'referred_by_user_email': value['referredByUserEmail'],
        'promotion_code': value['promotionCode'],
    };
}

